const devBaseURL = "http://digital.a2china.cn/Handlers/CommonHandler.ashx";
const proBaseURL = "http://digital.a2china.cn/Handlers/CommonHandler.ashx";

export const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseURL: proBaseURL;

export const TIMEOUT = 5000;

// 中化-投资者服务
export const UID = "db7cdcfb-42f3-435d-a414-1ac2103b7c95";
export const URL = 'http://app1.a2china.cn/zhonghua/2021/InvestorService/';
export const STATE = 'ZHONGHUA';

// localStorage
export const ZH_WX_OPENID = 'ZH_WX_OPENID';